import { api } from './api';

/** PORTAL DE ESPORTES — backend/app/api/v1/endpoints/esportes_portal.py */

export interface Competicao {
  id: string;
  nome: string;
}

export interface PortalConfig {
  site_slug: string;
  site_nome: string;
  site_url: string;
  site_ativo: boolean;
  ativo: boolean;
  competicoes: string[];
  temporada: number | null;
  publicar_tabelas: boolean;
  publicar_clubes: boolean;
  publicar_atletas: boolean;
  publicar_pre_jogo: boolean;
  publicar_pos_jogo: boolean;
  marcar_noticias: boolean;
  antecedencia_dias: number;
  intervalo_min: number;
  autor_wp_id: number | null;
  autor_padrao_site: number | null;
  competicoes_disponiveis: Competicao[];
  ultima_execucao_em: string | null;
  rodando: boolean;
}

export type PortalConfigUpdate = Partial<
  Omit<
    PortalConfig,
    | 'site_slug'
    | 'site_nome'
    | 'site_url'
    | 'site_ativo'
    | 'autor_padrao_site'
    | 'competicoes_disponiveis'
    | 'ultima_execucao_em'
    | 'rodando'
  >
>;

export interface AutoresResposta {
  autores: { id: number; nome: string }[];
  erro: string | null;
}

export interface Publicacao {
  chave: string;
  tipo: string;
  wp_tipo: string;
  wp_id: number;
  url: string | null;
  publicado_em: string;
  atualizado_em: string;
}

export interface PortalStatus {
  site_slug: string;
  ativo: boolean;
  rodando: boolean;
  ultima_execucao_em: string | null;
  criados: number;
  atualizados: number;
  iguais: number;
  erros: string[];
  ultimo_erro: string | null;
  total_publicado: number;
  por_tipo: Record<string, number>;
  recentes: Publicacao[];
}

const base = (slug: string) => `/esportes-portal/sites/${encodeURIComponent(slug)}`;

export const esportesPortalApi = {
  sites: () => api.get<PortalConfig[]>('/esportes-portal/sites'),
  salvar: (slug: string, dados: PortalConfigUpdate) =>
    api.put<PortalConfig>(`${base(slug)}/config`, dados),
  autores: (slug: string) => api.get<AutoresResposta>(`${base(slug)}/autores`),
  status: (slug: string) => api.get<PortalStatus>(`${base(slug)}/status`),
  rodar: (slug: string) =>
    api.post<{ disparado: boolean; mensagem: string }>(`${base(slug)}/rodar`),
  desligar: (slug: string) => api.post<PortalConfig>(`${base(slug)}/desligar`),
};
